import React, { useState } from 'react';
import { Query, useApolloClient } from 'react-apollo';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import Button from 'components/common/Button';
import Spin from 'components/common/Spin';
import Select from 'components/form/Select';
import { GET_CURRICULA, GET_MODULES } from 'graphql/admin/curriculum';

const CopyModal = ({ exercise, onClose, onSubmit }) => {
  const [module, setModule] = useState();
  const [curriculumId, setCurriculumId] = useState();
  const client = useApolloClient();

  const loadModuleOptions = () =>
    client
      .query({
        query: GET_MODULES,
        variables: {
          curriculum_id: curriculumId,
        },
      })
      .then((resp) =>
        resp.data.modules.map((i) => ({ label: i.name, value: i.id })),
      );

  return (
    <Query query={GET_CURRICULA} fetchPolicy="cache-first">
      {({ data, loading }) => {
        if (loading) return <Spin spinning />;
        return (
          <Dialog open onClose={onClose}>
            <DialogTitle>Copy: {exercise.name}</DialogTitle>
            <DialogContent>
              <Select
                transformValue
                isMulti={false}
                label="Curriculum"
                value={curriculumId}
                onChange={setCurriculumId}
                options={data.curricula.map((i) => ({
                  label: i.name,
                  value: i.id,
                }))}
              />
              {curriculumId && (
                <Select
                  async
                  key={curriculumId}
                  defaultOptions
                  loadOptions={loadModuleOptions}
                  isMulti={false}
                  label="Module"
                  value={module}
                  onChange={setModule}
                />
              )}
            </DialogContent>
            <DialogActions>
              <Button
                disabled={!module}
                variant="contained"
                color="primary"
                onClick={() => onSubmit(module.value, exercise)}
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>
        );
      }}
    </Query>
  );
};

export default CopyModal;
